import {
  type EciVec3,
  eciToGeodetic,
  propagate,
  SatRec,
  gstime,
  ecfToEci,
  degreesLong,
  degreesLat,
  degreesToRadians,
  geodeticToEcf
} from "satellite.js";

import * as THREE from "three";

import { CAMERA, ObjectColor, RADIUS } from "../constants";
import { RadiansToDegrees } from "./common";

export const convertGeoToEci = (
  latitude: number,
  longitude: number,
  time: Dayjs
) => {
  const height = CAMERA.PERSPECTIVE.DISTANCE - RADIUS;

  const [x, y, z] = getEciCoord(latitude, longitude, height, time);
  const direction = new THREE.Vector3(x, y, z);
  direction.normalize().multiplyScalar(CAMERA.PERSPECTIVE.DISTANCE);

  return direction;
};

export const getEciCoord = (
  latitude: number,
  longitude: number,
  height: number,
  time: Dayjs
) => {
  const radianLatitude = degreesToRadians(latitude);
  const radianLongitude = degreesToRadians(longitude);
  const ecf = geodeticToEcf({
    longitude: radianLongitude,
    latitude: radianLatitude,
    height: 0
  });
  const gmst = gstime(time.toDate());
  const eci = ecfToEci(ecf, gmst);

  const { x, y, z } = eci;
  return [x, y, z];
};

export function getGeodetic(x: number, y: number, z: number, time: Date) {
  const gstm = gstime(time);
  const eci = ecfToEci({ x, y, z }, gstm);
  const geo = eciToGeodetic(eci, gstm);
  return geo;
}

export const getGeodeticDataFromSatrec = (satrec: SatRec, time: Dayjs) => {
  // 5초 단위로 변경
  const convertedTime = time
    .second(Math.floor(time.second() / 5) * 5)
    .millisecond(0);
  try {
    const timeDate = convertedTime.toDate();
    const positionAndVelocity = propagate(satrec, timeDate);
    const inclination = RadiansToDegrees(satrec.inclo);

    const positionEci = positionAndVelocity.position;
    if (positionEci instanceof Boolean) {
      throw new Error("positionEci is a boolean");
    }
    const gstm = gstime(timeDate);
    const geo = eciToGeodetic(positionEci as EciVec3<number>, gstm);

    let { longitude, latitude, height } = geo;
    longitude = degreesLong(longitude);
    latitude = degreesLat(latitude);

    return { longitude, latitude, height, inclination };
  } catch (error) {
    console.error("getGeodeticDataFromSatrec", error);
    return undefined;
  }
};
